import { useFindByQuery } from '../../graphql';

export const useAllProducts = (workspaceId: string) => {
  const { data, isLoading } = useFindByQuery({
    modelName: 'product',
    query: FIND_PRODUCTS,
    variables: { filter: { workspace: { eq: workspaceId } } },
  });
  return {
    products: data?.items,
    isLoading,
  };
};

const FIND_PRODUCTS = `
  query FindProducts($filter: ProductFilter) {
    findProducts(filter: $filter) {
      items {
        id        
        name
      }
    }
  }
`;
